export default {
  async getCheckoutInfo({ commit }) {
    try {
      const { data } = await this.$axios.get(
        `${this.$config.baseOfixApi}/e-commerce/v1/checkout/with-registration`,
      );
      commit('setCheckoutInfo', data);
    } catch {}
  },
  async getLoggedCheckoutInfo({ commit, state, rootGetters }, payload) {
    try {
      let constCenter = null;
      const costCenters = rootGetters['costCenters/costCenters'];
      const defaultCostCenter = rootGetters['auth/defaultCostCenter'];
      if (defaultCostCenter) {
        constCenter = defaultCostCenter;
      } else if (costCenters.length) {
        constCenter = costCenters[0];
      }

      const { data } = await this.$axios.get(`${this.$config.baseOfixApi}/e-commerce/v1/checkout`, {
        params: {
          costCenterId: state.checkoutLoggedForm?.costCenterId
            ? state.checkoutLoggedForm.costCenterId
            : constCenter?.id,
        },
      });

      commit('setCheckoutInfo', data);
      if (defaultCostCenter) {
        const main = data.deliveryAddresses.find(address => address.isDefault);
        console.log('main', main);
        if (main) {
          commit('setFormField', {
            field: 'deliveryAddressId',
            value: main.id,
            isLogged: true,
          });
        } else {
          commit('setFormField', {
            field: 'deliveryAddressId',
            value: data.deliveryAddresses[0].id,
            isLogged: true,
          });
        }
      } else {
        const main = data.deliveryAddresses.find(address => address.isDefault);
        if (main) {
          commit('setFormField', {
            field: 'deliveryAddressId',
            value: main.id,
            isLogged: true,
          });
        } else {
          commit('setFormField', {
            field: 'deliveryAddressId',
            value: data.deliveryAddresses[0].id,
            isLogged: true,
          });
        }
      }
    } catch {}
  },
};
